<div class="container-fluid">

  <h4 id="upper">Décaissements </h4>
  <div class="d-flex justify-content-end">

    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Programmes:
          <select type="text" name="searchTerm" class="form-select ms-2" aria-controls="tickets-table"
            [(ngModel)]="selectedProjet" (change)="processSelectedProjet()">
            <option [ngValue]="null">Tous les programmes</option>
            <option *ngFor="let item of projetItems" [ngValue]="item.reference"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div>

    <div *ngIf="showFiltre === true" class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Direction:
          <select type="text" name="searchTerm" class="form-select ms-2" aria-controls="tickets-table"
            [(ngModel)]="selectedDirection" (change)="filterDataByDirections()">
            <option [ngValue]="null">Toutes les directions</option>
            <option *ngFor="let item of directionItems" [ngValue]="item.reference"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div>
  </div>

  <p-tabView>

    <p-tabPanel header="En attente de décaissement ({{itemDecaissement ? itemDecaissement.length :0}})">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">
                </div>
              </div>

              <div class="table-responsive mt-3">
                <table class="table table-centered datatable dt-responsive nowrap"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                  <thead class="thead-light  rwd-table">
                    <tr>
                      <th>Code</th>
                      <th>Libellé</th>
                      <th>Total Ordonnacé</th>
                      <th>Total Décaissé</th>
                      <th>Reste à décaissé</th>
                      <th style="width: 120px;"></th>
                    </tr>
                  </thead>
                  <tbody *ngIf="isLoading === false">
                    <tr *ngFor="let item of paginateDecaissment; let index = index">
                      <td>{{item.code_activite}}</td>
                      <td>{{item.activite}}</td>
                      <td>{{item.total_ordonnance | formatMoney:null}}</td>
                      <td>{{item.total_decaisse | formatMoney:null}}</td>
                      <td>{{item.total_ordonnance - item.total_decaisse | formatMoney:null}}</td>
                      <td>

                        <button (click)="openModal(item)" title="Cliquez ici pour décaisser"
                          class="btn btn-success btn-sm">
                          <i class="mdi mdi-cancel font-size-18"></i> Décaissé </button>


                      </td>
                    </tr>
                  </tbody>
                </table>

                <div *ngIf="paginateDecaissment.length === 0 && isLoading === false"
                  class="d-flex justify-content-center">
                  <div class="container">
                    <div class="row">
                      <div class="text-center">
                        <h5 id="graycolor">Aucune donnée trouvée</h5>
                      </div>
                    </div>
                  </div>

                </div>
                <p-paginator (onPageChange)="onPageChangeDecaissemnt($event)" [first]="firstDecaissement"
                  [rows]="rowsDecaissement" [totalRecords]="totalRecords2" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
              </div>

            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Décaissements ({{items ? items.length : 0}}) ">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-md-2">
                <div class="col-sm-12 col-md-6">

                </div>


              </div>
              <div class="table-responsive mt-3">
                <table class="table table-centered datatable dt-responsive nowrap"
                  style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                  <thead class="thead-light  rwd-table">
                    <tr>
                      <th>Code</th>
                      <th>Libellé</th>
                      <th>Total Ordonnacé</th>
                      <th>Total Décaissé</th>
                      <th>Reste à décaissé</th>
                      <th style="width: 120px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of paginatedEncaissement; let index = index">
                      <td>{{item.code_activite}}</td>
                      <td>{{item.activite}}</td>
                      <td>{{item.total_ordonnance | formatMoney:null}}</td>
                      <td>{{item.total_decaisse | formatMoney:null}}</td>
                      <td>{{item.total_ordonnance - item.total_decaisse | formatMoney:null}}</td>
                      <td>


                        <button (click)="openModalHistoriqueDecaissement(item)" title="Cliquez ici pour voir le détails"
                          class="btn btn-success btn-sm">
                          <i class="mdi mdi-cancel font-size-18"></i> Détails </button>
                      </td>
                    </tr>

                  </tbody>
                </table>


                <div *ngIf="!paginatedEncaissement" class="d-flex justify-content-center">
                  <div class="container">
                    <div class="row">
                      <div class="text-center">
                      </div>
                    </div>
                  </div>
                </div>
                <p-paginator (onPageChange)="onPageEncaissement($event)" [first]="firstEncaissement"
                  [rows]="rowsEncaissemnt" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>


  </p-tabView>
</div>




<ng-template #decaisemmentModal let-modal>

  <div class="modal-header">
    <h5 class="modal-title">Décaissement</h5>
    <button (click)="modal.dismiss('Close click')" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form>


        <!-- ligne de montants -->
        <div class="d-flex">

          <div class="form-group col-md-4 ">
            <label for="name">Total Ordonnancé</label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.total_ordonnance" disabled
              name="total_engage" type="number" class="form-control" id="name" placeholder="Total ordonnancé">
          </div> &nbsp;

          <div class="form-group  col-md-4 me-2">
            <label for="name">Total décaissé </label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.total_decaisse" disabled
              name="total_decaisse" type="number" class="form-control" id="name" placeholder="0 ">

          </div>

          <div class="form-group  col-md-4 me-2">
            <label for="name">Reste</label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.reste" disabled name="reste"
              type="number" class="form-control" id="name" placeholder="0 ">

          </div>
        </div><br>

        <div class="d-flex">
          <div class="form-group  col-md-8 me-2">
            <label for="name">Activité Opérationelle</label>
            <textarea style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.activite" name="libelle"
              type="text" class="form-control" disabled placeholder="Libellé ">

            </textarea>
          </div>
          <div class="form-group col-md-4">
            <label for="name">Inputation Budgétaire</label>
            <input style="background-color: aliceblue;" [(ngModel)]="sousActiviteItem.amputation_budgetaire" name="code"
              type="text" class="form-control" id="name" disabled placeholder="Code">
          </div> &nbsp;

        </div><br>

        <!-- ligne de montants -->
        <div class="d-flex">
          <div class="form-group col-md-6 me-2">
            <label for="email">Décaissée le</label>
            <input type="date" [(ngModel)]="sousActiviteItem.date_decaissement" name="date_decaissement"
              class="form-control" id="date" placeholder="">
          </div>
          <div class="form-group  col-md-6">
            <label for="name">Montant à décaisser</label>
            <input [(ngModel)]="sousActiviteItem.total_a_decaisser" name="total_a_decaisser" type="number"
              class="form-control" id="name" placeholder=" Montant décaissé " (ngModelChange)="calculateReste()">

          </div> &nbsp;


        </div><br>


        <div class="row">
          <div class="form-group col-md-12">
            <label for="email">Référence pièce</label>
            <input type="text" [(ngModel)]="sousActiviteItem.no_fichier" name="no_fichier" class="form-control"
              id="date" placeholder="">
          </div>&nbsp;
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="email">Preuve</label>
            <input type="file" (change)="onFileSelected($event)" name="no_fichier" class="form-control" id="date"
              placeholder="">
          </div>
             <div class="form-group col-md-6">
            <label for="email">Observations</label>
            <textarea type="text" name="observations" [(ngModel)]="sousActiviteItem.observations" class="form-control"
              id="observations" placeholder=""> </textarea>
          </div>
        </div>

<br>
        <div class="text-end">
          <div class="text-end">
            <button (click)="modal.dismiss('Close click')" type="button" class="btn btn-light ms-1"> <i
                class="pi pi-times" style="color: #212529"></i> Annuler</button> &nbsp;
            <button (click)="saveEncaissement()" type="submit" class="btn btn-success"> <i class="pi pi-save"
                style="color: white"></i>
              Décaisser</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #decaissementtModalDetail let-modal>

  <div class="modal-header">
    <h5 class="modal-title">Historique de décaissement</h5>
    <button (click)="modal.dismiss('Close click')" type="button" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">

    <!-- Loader -->
    <div *ngIf="isLoadingDecaissement" class="text-center">
      <p>Chargement...</p>
    </div>

    <!-- Table -->
    <div class="table-responsive" *ngIf="!isLoadingOrdonnancement && historicDecaissement?.length > 0">
      <table class="table table-bordered table-hover">
        <thead class="table-light">
          <tr>
            <th class="text-center">Date de décaissement</th>
            <th class="text-center">Montant décaissé</th>
            <th class="text-center">Numéro de decaissment</th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of historicDecaissement">
            <td class="text-center">
              {{ item.date_decaissement | date:'dd/MM/yyyy' }}
            </td>
            <td class="text-end">
              {{ item.mt_decaissement | formatMoney:null }}
            </td>
            <td class="text-center">
              {{ item.no_fichier || '-' }}
            </td>

            <td class="text-center">
              <div class="d-flex justify-content-center align-items-center gap-2">

                <button (click)="cancelEncaissement(item)" title="Cliquez ici pour annuler"
                  class="btn btn-success btn-sm d-flex align-items-center">
                  <i class="mdi mdi-cancel me-1"></i> Annuler
                </button>

                <button (click)="exportToDocument(item)" title="Cliquer ici pour télécharger une fiche"
                  class="btn btn-secondary btn-sm d-flex align-items-center">
                  <i class="pi pi-download me-1"></i> Fiche
                </button>

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Aucun résultat -->
    <div *ngIf="!isLoadingDecaissement && historicDecaissement?.length === 0" class="text-center">
      <p>Aucun décaissement trouvé</p>
    </div>

  </div>

</ng-template>
<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>
